import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEllipse = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 210,
	height: 210,
	viewBox: "0 0 210 210",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 105,
		cy: 105,
		r: 104,
		stroke: "#DFCBF5",
		strokeOpacity: .7,
		strokeLinecap: "round",
		strokeDasharray: "0.1 12"
	})
});
export default SvgEllipse;
